import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import GuaranteeIcon from "../../Assets/Images/guarantee-icon.svg";
import AcceleratedIcon from "../../Assets/Images/accelerate-benefit-icon.svg";
import PolicyIcon from "../../Assets/Images/policy-icon.svg";
import AutomaticIcon from "../../Assets/Images/automatic-benefit-icon.svg";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook
import coverImage from "../../Assets/Images/Select-1.png"; // Adjust the path as necessary
import coverImage2 from "../../Assets/Images/Select-2.png"; // Adjust the path as necessary

export default function BenefitsMobileSlider() {
  const translations = useTranslation(); // ✅ Only declared once

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
  };

  return (
    <Slider {...settings} className="vs-slider relative  w-[100%]  pl-[20px] ">
      {/* Slide 1 */}
      <div className="flex-1 shrink pt-[60px] lg:pt-[60px] md:pt-[8rem]  lg:px-0 lg:w-[50%]">
        <div className="pb-[5%] px-4 reveal-up">
          <div className="text-sm text-gray-600 mb-1 learnmoreacc">
            {translations.select_term}
          </div>
          <div className="text-[24px] leading-[28px] md:text-[30px] md:leading-[33px] lg:text-[40px] lg:leading-[44px]">
            <span className="font-semibold">{translations.main_benefits}</span>{" "}
            {translations.of_the_policy}
          </div>
        </div>
        <div className="-mr-4 md:mr-0 md:pl-4 flex md:max-w-[664px] overflow-hidden md:overflow-visible reveal-up">
          <img
            src={coverImage}
            alt="Select-1"
            className="w-[130%] md:w-full max-w-none h-auto"
          />
        </div>
        <div className="py-[40px] px-4">
          <div className="flex pb-[1rem] md:pb-[1.5rem] reveal-up reveal-delay-1">
            <div className="pe-[1.8rem] flex-none">
              <img src={GuaranteeIcon} className="w-[84px]" />
            </div>
            <div className="max-w-[355px]">
              <h3 className="md:text-[18px] md:leading-[22px] text-[16px] font-semibold md:mb-2.5 mb-2">
                {translations.guaranteed_premiums_title}
              </h3>
              <p className="md:text-[12px] md:leading-[17px] text-[14px]">
                {translations.guaranteed_premiums_desc}
              </p>
            </div>
          </div>
          <div className="flex reveal-up reveal-delay-2">
            <div className="pe-[1.8rem] flex-none">
              <img src={PolicyIcon} className="w-[84px]" />
            </div>
            <div className="max-w-[355px]">
              <h3 className="md:text-[18px] md:leading-[22px] text-[16px] font-semibold md:mb-2.5 mb-2">
                {translations.conversion_option_title}
              </h3>
              <p className="md:text-[12px] md:leading-[17px] text-[14px]">
                {translations.conversion_option_desc}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Slide 2 */}
      <div className="flex-1 shrink pt-[60px] lg:pt-[60px] md:pt-[8rem]  lg:px-0 lg:w-[50%] ">
        <div className="pb-[5%] px-4 reveal-up">
          <div className="text-sm text-gray-600 mb-1 learnmoreacc">
            {translations.select_term}
          </div>
          <div className="text-[24px] leading-[28px] md:text-[30px] md:leading-[33px] lg:text-[40px] lg:leading-[44px]">
            <span className="font-semibold">{translations.main_benefits}</span>{" "}
            {translations.of_the_policy}
          </div>
        </div>
        <div className="-mr-4 md:mr-0 md:pl-4 flex md:max-w-[664px] overflow-hidden md:overflow-visible reveal-up">
          <img
            src={coverImage2}
            alt="Select-2"
            className="w-[130%] md:w-full max-w-none h-auto"
          />
        </div>
        <div className="py-[40px] px-4">
          <div className="flex pb-[1rem] md:pb-[1.5rem] reveal-up reveal-delay-1">
            <div className="pe-[1.8rem] flex-none">
              <img src={AcceleratedIcon} className="w-[84px]" />
            </div>
            <div className="max-w-[355px]">
              <h3 className="md:text-[18px] md:leading-[22px] text-[16px] font-semibold md:mb-2.5 mb-2">
                {translations.acceleratedDeathBenefitTitle}
              </h3>
              <p className="md:text-[12px] md:leading-[17px] text-[14px]">
                {translations.acceleratedDeathBenefitDesc}
              </p>
            </div>
          </div>
          <div className="flex reveal-up reveal-delay-2">
            <div className="pe-[1.8rem] flex-none">
              <img src={AutomaticIcon} className="w-[84px]" />
            </div>
            <div className="max-w-[355px]">
              <h3 className="md:text-[18px] md:leading-[22px] text-[16px] font-semibold md:mb-2.5 mb-2">
                {translations.automaticBenefitRiderTitle}
              </h3>
              <p className="md:text-[12px] md:leading-[17px] text-[14px]">
                {translations.automaticBenefitRiderDesc}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Slider>
  );
}
